import { render, staticRenderFns } from "./homeBlogWrapper.vue?vue&type=template&id=93c23d44&scoped=true&lang=html&"
import script from "./homeBlogWrapper.vue?vue&type=script&lang=js&"
export * from "./homeBlogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./homeBlogWrapper.vue?vue&type=style&index=0&id=93c23d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c23d44",
  null
  
)

export default component.exports